import React from 'react';
import { ClipboardCheckIcon, HeartHandshakeIcon, UsersIcon, LineChartIcon } from 'lucide-react';
export const HowItWorks: React.FC = () => {
  return <section id="how-it-works" className="py-16 md:py-24 bg-cloud" data-id="element-169">
      <div className="section-container" data-id="element-170">
        <div className="text-center mb-16" data-id="element-171">
          <h2 className="text-3xl md:text-4xl font-literata font-medium text-deep-juniper mb-4" data-id="element-172">
            How It Works
          </h2>
          <p className="text-lg text-plum-gray max-w-2xl mx-auto" data-id="element-173">
            Our comprehensive approach combines technology and human expertise
            to create a personalized healing journey.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-174">
          {/* Smart Intake */}
          <div className="card hover:translate-y-[-8px] transition-all duration-300" data-id="element-175">
            <div className="w-14 h-14 rounded-full bg-rejoy-coral/20 flex items-center justify-center mb-4" data-id="element-176">
              <ClipboardCheckIcon className="text-rejoy-coral" size={28} data-id="element-177" />
            </div>
            <h3 className="text-xl font-literata font-medium text-deep-juniper mb-3" data-id="element-178">
              Smart Intake
            </h3>
            <p className="text-plum-gray" data-id="element-179">
              Your journey starts with our AI-guided intake — combining your
              story, history, and biometric data to design a personalized
              treatment plan.
            </p>
          </div>
          {/* Personalized Care Plan */}
          <div className="card hover:translate-y-[-8px] transition-all duration-300" data-id="element-180">
            <div className="w-14 h-14 rounded-full bg-deep-juniper/20 flex items-center justify-center mb-4" data-id="element-181">
              <HeartHandshakeIcon className="text-deep-juniper" size={28} data-id="element-182" />
            </div>
            <h3 className="text-xl font-literata font-medium text-deep-juniper mb-3" data-id="element-183">
              Personalized Care Plan
            </h3>
            <p className="text-plum-gray" data-id="element-184">
              Each plan adapts over time. As you heal, Re:Joy continuously
              refines your therapy — ensuring that every session, method, and
              therapist supports lasting progress.
            </p>
          </div>
          {/* Community Sessions */}
          <div className="card hover:translate-y-[-8px] transition-all duration-300" data-id="element-185">
            <div className="w-14 h-14 rounded-full bg-mint-sage/40 flex items-center justify-center mb-4" data-id="element-186">
              <UsersIcon className="text-deep-juniper" size={28} data-id="element-187" />
            </div>
            <h3 className="text-xl font-literata font-medium text-deep-juniper mb-3" data-id="element-188">
              Community Sessions
            </h3>
            <p className="text-plum-gray" data-id="element-189">
              Healing is stronger when shared. Our guided small groups create
              safe spaces to connect with others on similar paths.
            </p>
          </div>
          {/* Optimal Healing */}
          <div className="card hover:translate-y-[-8px] transition-all duration-300" data-id="element-190">
            <div className="w-14 h-14 rounded-full bg-apricot/30 flex items-center justify-center mb-4" data-id="element-191">
              <LineChartIcon className="text-deep-juniper" size={28} data-id="element-192" />
            </div>
            <h3 className="text-xl font-literata font-medium text-deep-juniper mb-3" data-id="element-193">
              Optimal Healing
            </h3>
            <p className="text-plum-gray" data-id="element-194">
              Our system continuously measures progress and stress indicators to
              optimize your sessions and sustain recovery.
            </p>
          </div>
        </div>
      </div>
    </section>;
};